<template>
<!-- 
The header sensitivity was on the `a` element. We put it on the `card-header` div.

Changes:
- Moved ` @click.prevent="activate"` from `a` to the parent div
- Removed `<i class="tim-icons icon-minimal-down"></i>`
- Added styles to the `after` pseudo-element 
- Changed default value of `active` from false to true

"Not a card" changes:
- Removed the `card` class
- Default value of `active` set to false
-->

  <div>
    <div role="tab" class="card-header" :aria-expanded="active" @click.prevent="activate">
      <a
        data-toggle="collapse"
        data-parent="#accordion"
        :href="`#${itemId}`"
        
        :aria-controls="`content-${itemId}`"
      >
        <slot name="title"> {{ title }} </slot>
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div
        v-show="active"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div class="card-body"><slot></slot></div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'collapse-item',
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: '',
      description: 'Collapse item title'
    },
    id: String
  },
  inject: {
    animationDuration: {
      default: 250
    },
    multipleActive: {
      default: false
    },
    addItem: {
      default: () => {}
    },
    removeItem: {
      default: () => {}
    },
    deactivateAll: {
      default: () => {}
    }
  },
  computed: {
    itemId() {
      return this.id || this.title;
    }
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    activate() {
      let wasActive = this.active;
      if (!this.multipleActive) {
        this.deactivateAll();
      }
      this.active = !wasActive;
    }
  },
  mounted() {
    this.addItem(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeItem(this);
  }
};
</script>

<style scoped>

  .card-header {
    padding-top: 0;
    border-bottom: none;
  }
  .card-body {
    padding-top: 0;
    padding-bottom: 0;
  }
  .card-header:after {
    content: "\e6e1";
    font-family: element-icons!important;
    font-weight: 900;
    top: 10px;
  }

</style>
